export const findByArrOfWords = (string = '', arrOfWords = []) => {
    let hasMatch = false;
    for (const word of arrOfWords) {
      if (string.includes(word)) {
        hasMatch = true;
        break;
      }
    }
    return hasMatch;
  };